export default {"src":"/_next/static/media/ic-console.c93667cd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};